
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payment-policy",
      function () {
        return require("private-next-pages/payment-policy.tsx");
      }
    ]);
  